<template>
  <div id="main-home">
    <div id="home">
      <v-container class="container_prop">
        <section id="cards-home">
          <CardsHome @openQuotationDialog="showModal = true" />
        </section>
      </v-container>

      <!-- <section id="text-animation">
      <TextAnimationHome />
    </section>

    <section id="calculator">
      <CardCalculator />
    </section> -->
    </div>

    <div id="middle-section">
      <section id="seen-in">
        <SeenIn />
      </section>
      <section id="video">
        <VideoHome />
      </section>

      <section id="cards-aux">
        <AuxiliaryCards />
      </section>
    </div>

    <section id="testimonial-section">
      <TestimonialSection />
    </section>

    <section id="faq-footer">
      <FaqFooter />
    </section>

    <section id="base-footer">
      <v-footer>
        <CopyrightFooter />
      </v-footer>
    </section>

    <BackToTop />
  </div>

  <QuotationDialog
    v-model="showModal"
    @success="showSnackbar('success', $event)"
    @error="showSnackbar('error', $event)"
  />

  <SnackbarFeedback
    v-model="snackbar.show"
    :color="snackbar.color"
    :message="snackbar.message"
  />
</template>

<script>
import CardsHome from "@/components/layout/Home/CardsHome.vue";
import BackToTop from "@/components/common/BackToTop.vue";
import SeenIn from "@/components/layout/Home/SeenIn.vue";
import AuxiliaryCards from "@/components/layout/Home/AuxiliaryCards.vue";
import VideoHome from "@/components/layout/Home/VideoHome.vue";
import TestimonialSection from "@/components/layout/Home/TestimonialSection.vue";
import FaqFooter from "@/components/layout/Home/FaqFooter.vue";
import CopyrightFooter from "@/layout/Footer.vue";
import QuotationDialog from "@/components/layout/Home/QuotationsDialog.vue";
import SnackbarFeedback from "@/components/common/SnackbarFeedback.vue";

export default {
  name: "HomePage",
  components: {
    CardsHome,
    SeenIn,
    AuxiliaryCards,
    VideoHome,
    TestimonialSection,
    FaqFooter,
    CopyrightFooter,
    QuotationDialog,
    SnackbarFeedback,
    BackToTop,
  },
  data() {
    return {
      quotationText: "",
      quotationImage: null,
      showModal: false,
      loading: false,
      snackbar: {
        show: false,
        color: "",
        message: "",
      },
    };
  },
  methods: {
    showSnackbar(color, message) {
      this.snackbar = {
        show: true,
        color,
        message,
      };
    },
  },
};
</script>

<style lang="css" scoped>
@media (max-width: 537px) {
  .container_prop {
    max-width: 95vw !important;
  }
}

.container_prop {
  max-width: 80vw;
  margin: 20px auto 60px auto;
}

@import url("https://fonts.googleapis.com/css?family=Heebo:400,700|Open+Sans:400,700");

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  font-family: "Open Sans";
  background: rgb(21, 20, 20);
}

#calculator {
  background-color: rgb(21, 20, 20);
}

#home {
  width: 100%;
}

#cards-aux {
  margin-bottom: 60px;
}

.v-footer {
  background-color: #f5f5f5;
}

#testimonial-section {
  background-color: #fdd835;
  height: 550px;
}

#base-footer {
  background-color: #f5f5f5;
}

#cards-aux {
  padding-bottom: 50px;
  margin-bottom: 0px;
}
.v-theme--dark {
  background-color: #151414;
}

#base-footer .v-theme--light {
  background-color: #f5f5f5;
}

#base-footer .v-theme--dark {
  background-color: #f5f5f5;
}

.v-theme--light {
  background-color: #fff;
}

#main-home {
  overflow-x: hidden;
}

#middle-section {
  background-color: #f5f5f5;
}
@media screen and (max-width: 959px) {
  #testimonial-section {
    height: 900px;
    padding: 15px;
  }
}
</style>
